import AtlStorage from 'api/AtlStorage';

export const cartProperties = (cartId) =>
  new AtlStorage(`btf.cart.${cartId}.properties`, window.localStorage);
export const clearedCartId = new AtlStorage('btf.cleared.cart.uuid', window.localStorage);
